export const config = {
    hostUrl: 'https://api.finsentinel-uat.finfactor.in',
    apiBasePrefixV1: '/finsentinel/api/v1',
    consentPath: "/consent",
};
